import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=08468b06&scoped=true&"
import script from "./Navigation.vue?vue&type=script&lang=js&"
export * from "./Navigation.vue?vue&type=script&lang=js&"
import style0 from "./Navigation.vue?vue&type=style&index=0&id=08468b06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08468b06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/dealerdraft/dealerdraft/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VNavigationDrawer } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarItems } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon,VList,VListTile,VListTileTitle,VNavigationDrawer,VSpacer,VToolbar,VToolbarItems,VToolbarTitle})
